import React from 'react';
import { testimonials } from '../mock';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section className="py-24 bg-[#f7f5f2]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-5xl md:text-6xl font-bold text-[#1a1a2e] tracking-tight">
            What Our Customers Say
          </h2>
          <p className="text-lg text-[#666] max-w-2xl mx-auto">
            Read authentic reviews from our satisfied customers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white p-8 rounded-sm shadow-lg hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="flex items-start justify-between mb-6">
                <Quote size={40} className="text-[#dc143c] opacity-30" />
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={18} className="fill-[#dc143c] text-[#dc143c]" />
                  ))}
                </div>
              </div>

              <p className="text-base text-[#666] leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              <div className="flex items-center justify-between pt-6 border-t border-[#f7f5f2]">
                <div>
                  <p className="text-lg font-bold text-[#1a1a2e]">{testimonial.name}</p>
                  <p className="text-sm text-[#666]">
                    {new Date(testimonial.date).toLocaleDateString('en-US', {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric'
                    })}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
